import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import type { Path } from '~/types/util'
import { PlanType } from '~/generated/api-clients-generated'
import { SessionStore } from '~/stores/session'

export class NeedsOutboundContactInfoNode extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    const { skipContactEntry } = OutboundLead.use()

    const { flag } = FeatureFlags.use()
    const session = SessionStore.use()

    const showOutboundForPdp = flag<boolean>('outbound-lead-on-pdp').value

    if (!showOutboundForPdp && (session.planType === PlanType.PDP || session.pdpUpsell)) {
      return this.yesNo(false)
    }

    return this.yesNo(!skipContactEntry.value)
  }
}
